import { supabase } from "@/integrations/supabase/client";
import { detectPlatform, isStandalone } from "@/lib/pwa-stats";

const DEVICE_KEY = "albazar-device-id";

export function deviceId(): string {
  if (typeof localStorage === "undefined") return "";
  let id = localStorage.getItem(DEVICE_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(DEVICE_KEY, id);
  }
  return id;
}

function browserName(ua = navigator.userAgent) {
  if (/Edg\//.test(ua)) return "Edge";
  if (/OPR\//.test(ua)) return "Opera";
  if (/SamsungBrowser/.test(ua)) return "Samsung Internet";
  if (/Chrome\//.test(ua)) return "Chrome";
  if (/Firefox\//.test(ua)) return "Firefox";
  if (/Safari\//.test(ua)) return "Safari";
  return "Digər";
}

/** Ziyarəti bazada qeyd edir (hər səhifə keçidi üçün bir dəfə). */
export async function trackVisit(path: string) {
  if (typeof window === "undefined" || window.self !== window.top) return;
  const { data } = await supabase.auth.getSession();
  await supabase
    .from("site_visits")
    .insert({
      device_id: deviceId(),
      user_id: data.session?.user.id ?? null,
      path: path.slice(0, 300),
      referrer: document.referrer ? document.referrer.slice(0, 300) : null,
      platform: detectPlatform(),
      browser: browserName(),
      is_pwa: isStandalone(),
    })
    .then(() => undefined, () => undefined);
}

/** Elan paylaşmasını qeyd edir. */
export async function trackShare(listingId: string | null, channel: string) {
  if (typeof window === "undefined") return;
  const { data } = await supabase.auth.getSession();
  await supabase
    .from("share_events")
    .insert({
      listing_id: listingId,
      channel,
      device_id: deviceId(),
      user_id: data.session?.user.id ?? null,
    })
    .then(() => undefined, () => undefined);
}

let lastError = "";

/** Brauzerdə baş verən xətanı monitorinq üçün göndərir. */
export async function logClientError(message: string, stack?: string) {
  if (typeof window === "undefined" || !message) return;
  // Axtarış botları (Google, Meta və s.) səhifəni yarımçıq icra edir — onların xətaları real istifadəçi xətası deyil
  if (/bot|crawl|spider|compatible;|headless|lighthouse/i.test(navigator.userAgent)) return;
  if (message === lastError) return;
  lastError = message;
  const { data } = await supabase.auth.getSession();
  await supabase
    .from("client_errors")
    .insert({
      message: message.slice(0, 500),
      stack: stack ? stack.slice(0, 4000) : null,
      path: window.location.pathname.slice(0, 300),
      user_agent: navigator.userAgent.slice(0, 400),
      user_id: data.session?.user.id ?? null,
    })
    .then(() => undefined, () => undefined);
}

/** Qlobal xəta monitorinqini işə salır. */
export function initErrorMonitoring() {
  if (typeof window === "undefined") return;
  window.addEventListener("error", (e) => {
    void logClientError(e.message, e.error instanceof Error ? e.error.stack : undefined);
  });
  window.addEventListener("unhandledrejection", (e) => {
    const r = e.reason;
    void logClientError(
      r instanceof Error ? r.message : String(r ?? "Naməlum xəta"),
      r instanceof Error ? r.stack : undefined,
    );
  });
}
